(function() {
  'use strict';

  function PendingSectionSearch($q, $filter, $translate) {
    var STATES = {
      accepted: $translate.instant('Accepted'),
      rejected: $translate.instant('Rejected')
    };

    var getSearch = function() {
      var search = {
        facetly: {
          facets: [
            {
              id: 'text',
              type: 'search',
              label: $translate.instant('Start typing to search')
            },
            {
              id: 'state',
              type: 'select',
              label: $translate.instant('State'),
              options: _.map(STATES, function(value, key) {
                return { id: key, title: value };
              }),
              facetly: false,
              advanced: false
            }
          ],
          options: {
            defaultFacet: 'text',
            placeholder: $translate.instant('Start typing to search...'),
            listMaxItems: 10
          }
        },
        orderGroups: {
          eventType: {
            title: $translate.instant('event type'),
            orders: ['eventType', 'createdDate'],
            groupBy: {
              title: $translate.instant('Event type is'),
              notitle: $translate.instant('No event type'),
              templateUrl: 'app/components/admin/eventType.wrapper.html',
              getter: function(item) {
                return item.doc.eventTypeName;
              }
            }
          },
          submittedDate: {
            title: $translate.instant('date submitted'),
            orders: ['submittedDate'],
            groupBy: {
              title: $translate.instant('Submitted in'),
              notitle: $translate.instant('Submittion unknown'),
              getter: function(item) {
                return $filter('date')(item.doc.submittedDate, 'MMMM y');
              }
            }
          },
          username: {
            title: $translate.instant('response from'),
            groupBy: {
              title: $translate.instant('Response from'),
              notitle: $translate.instant('No user'),
              getter: function(item) {
                return item.doc.userFullname;
              }
            }
          },
          owner: {
            title: $translate.instant('event owner'),
            groupBy: {
              title: $translate.instant('Event owner'),
              notitle: $translate.instant('No owner'),
              getter: function(item) {
                return item.doc.eventOwnerFullname;
              }
            }
          }
        },
        defaultOrder: 'eventType'
      };

      return $q.when(search);
    };

    return {
      search: getSearch()
    };
  }

  PendingSectionSearch.$inject = ['$q', '$filter', '$translate'];

  angular.module('component.admin')
    .service('PendingSectionSearch', PendingSectionSearch);
})();
